import * as React from 'react'

import { observer } from 'mobx-react'

import EditDimensionValueSidepanel from 'modules/finance/components/Dimensions/EditDimensionValueSidepanel'

interface Props {
  id: number
  open: boolean
  onClose: (success?: boolean) => void
}

const EditDimensionValuePanel = ({ id, open, onClose }: Props) => {
  return <>{open && <EditDimensionValueSidepanel value_id={id} onClose={onClose} />}</>
}

export default observer(EditDimensionValuePanel)
